// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { navigationDrawerStyles } from "@west/Overrides/Components/NavigationDrawer";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.mainNavigationRowTypography = {
    transform: "capitalize",
    color: "text",
    weight: "normal",
    size: 14,
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &.separate {
            padding-top: 16px;
            margin-top: 16px;
            border-top: 1px solid ${color("common.border")};
        }

        &.tablet {
            display: none;

            ${xScreen("lte", "md")} {
                display: block;
            }
        }
        &.mobile-only {
            display: none;

            ${xScreen("lt", "sm")} {
                display: block;
            }
        }
    `,
};

navigationDrawerStyles.menuTriggerButton = {
    size: 32,
    css: css`
        &,
        &:not(:disabled):focus,
        &:not(:disabled):hover {
            border: 1px solid ${color("common.border")};
            border-radius: 2px;
            background-color: ${color("common.white")};
            padding: 6px;
            ${IconWrapper} {
                top: 0;
                color: ${color("common.ui6")};
                &,
                & > svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    `,
};
